import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ProjectItemEntity } from './project-item.entity';
import { ProjectListEntity } from './project-list.entity';

@Injectable()
export class ProjectListProvider {
	private readonly projectList: ProjectListEntity;

	public constructor() {
		this.projectList = ProjectListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.project.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 0,
			},
			{
				field: 'version',
				alias: $localize`:i18n=@@subscription.project.list.column.version:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 1,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@subscription.project.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 2,
			},
			{
				field: 'tags',
				alias: $localize`:i18n=@@subscription.project.list.column.tags:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 3,
			},
		]);
	}

	public getList(): ProjectListEntity {
		return this.projectList;
	}

	public setListElements(
		elements: Map<string, ProjectItemEntity>
	): ProjectListEntity {
		return this.projectList.setElements(elements);
	}
}
